import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';

class UploadFileModalController implements angular.IComponentController {
    displayFilename: string;
    fileList: FileList;
    filename: string;
    fileBase64: any;
    isLoading: boolean;
    loadingMessage: string;
    modalId: string;
    types: string;

    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this._$scope.$watch(() => this.fileList, () => {
            if (this.fileList && this.fileList.length) {
                const file = this.fileList[0];
                this.displayFilename = file.name;
                this.fileToBase64(file);
            }
        });

        this._$scope.$watch(() => this.filename, () => this.displayFilename = this.filename);

        if (!this.types) {
            this.types = 'image/*';
        }
    }

    fileToBase64(file: File) {
        const r = new FileReader();

        // Callback after files finish loading
        r.onloadend = (e: any) => {
            this.fileBase64 = e.target.result;
            this._$scope.$apply();
        };

        r.readAsDataURL(file);
    }

    close() {
        this.filename = this.displayFilename;
    }
}

export const wtUploadFileModal: ComponentDefinition = {
    componentId: 'wtUploadFileModal',
    controller: UploadFileModalController,
    template: require('./uploadFileModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        fileList: '=',
        filename: '=',
        fileBase64: '<',
        modalId: '@',
        types: '@?'
    }
};